<template>
  <div v-if="ready">
    <form
      class="form-horizontal"
      enctype="multipart/form-data"
      @keydown="form.errors.clear($event.target.name)"
      autocomplete="off"
    >
      <form-input :form="form" name="name" required></form-input>

      <backend-select :error="form.errors.get('action_document_category_id')" required return="id" name="category"
                      :value="field('action_document_category_id')" v-model="form.action_document_category_id"
                      :route="route('action-document-categories.index')"
                      label="template_category"
      />

      <title-with-title-display
        :error="form.errors.get('title')"
        name="title"
        v-model="title"
        required
      />

      <yes-no-select :error="form.errors.get('needs_to_be_checked')"
                     v-model="form.needs_to_be_checked"
                     name="needs_to_be_checked"
      />

      <!-- concepts disabled
          <yes-no-select :error="form.errors.get('is_concept')" v-model="form.is_concept" name="is_concept"/>
       -->

      <ckeditor v-model="form.template" name="template"/>

      <backend-select :form="form" :error="form.errors.get('blik_op_werk_category_id')" name="blik_op_werk_category_id" return="id"
                            label="service_according_to_blik_op_werk" :route="route('admin.settings.values.to_blik_op_werk')"
                            :value="field('blik_op_werk_category_id')" v-model="form.blik_op_werk_category_id" trackBy="value" object-name-key="value"/>

      <yes-no-select :error="form.errors.get('is_archived')"
                     v-model="form.is_archived"
                     name="is_archived"
      />
    </form>

    <div class="form-group">
      <input :disabled="form.busy"
             type="button"
             @click.prevent="store"
             class="btn btn-brand"
             :value="uLang('app.save')"
      />
    </div>
  </div>
</template>

<script>
  import Ckeditor from '~/components/elements/action-document-ckeditor'
  import Form from '~/Form/Form'
  import { event } from '~/events'
  import FormMixin from '~/mixins/form'
  import YesNoSelect from '~/components/elements/selects/yes-no'
  import TitleWithTitleDisplay from '../../../elements/title-with-title-display';
  import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
  import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";
  import { ErrorAlert } from '~/Swals'

  export default {
    name: 'form-admin-action-document',
    mixins: [FormMixin],

    components: {
      TitleWithTitleDisplay,
      'ckeditor': Ckeditor,
      'yes-no-select': YesNoSelect,
    },

    props: {
      id: {
        required: false,
      },
    },

    data() {
      return {
        action_document: {},
        entity: 'action-documents',
        form: new Form({
          name: '',
          title: null,
          title_display: 0,
          action_document_category_id: null,
          needs_to_be_checked: 0,
          blik_op_werk_category_id: null,
          is_archived: 0,
          //  is_concept: 1, // concepts disabled
          template: '',
        }),
        title: {
          title: null,
          title_display: 0,
        },
        swal: false,
      }
    },

    created() {
      this.$on('afterStore', this.afterStore);
      this.$on('afterUpdate', this.afterUpdate);
      this.$on('onError', this.paniek);

      this.$on('afterRetrieve', data => {
        this.action_document = data;
        this.title = {
          title: this.form.title,
          title_display: this.form.title_display,
        };
      });
    },

    watch: {
      title() {
        this.form.title = this.title.title;
        this.form.title_display = this.title.title_display;
      },
    },

    methods: {
      paniek() {
        const templateError = this.form.errors.errors['template'][0];
        if (templateError) {
          new ErrorAlert({ 'text': templateError }).show()
        }
      },
      afterStore(data) {
        new SuccessfullyStoredAlert({ entity: this.lang('app.action_document') }).show()
          .then((buttonPressed) => {
            if (buttonPressed === 'create_another') {
              // Form mixin clears fields already
            } else if (buttonPressed === 'show') {
              this.$router.push({
                name: 'admin.action-documents.view', params: {
                  id: data.id,
                }
              });
            }
          });
      },

      afterUpdate(data) {
        new SuccessfullyUpdatedAlert({ entity: this.lang('app.action_document') }).show()
          .then(() => {
            this.$router.push({
              name: 'admin.action-documents.view', params: {
                id: this.id,
              }
            });
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    overflow: inherit;
  }
</style>
